<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(v-if="isKey" :HeaderGlobalHeading="`Search '${ keyword }'`" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        HeaderGlobal(v-else HeaderGlobalHeading="No keyword found!" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__body
                .box-tabs(class="lg:pt-4 pt-0")
                    SourceUniversity

</template>

<script>
import { decrypt } from '@/util/crypto';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import SourceUniversity from './SourceUniversity.vue'

export default {
    name: 'PageUnivName',
    components: {
        HeaderGlobal,
        Spinner,
        SourceUniversity,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Search University Name',
                    url: '/search-univ-name',
                },
            ],
            keyword: '',
            data_result: [],
        }
    },
    computed: {
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            return this.key ? true : false;
        },
    },
    watch: {
        key() {
            this.getData(true);
        },
        isKey() {},
        breadcrumb() {},
    },
    methods: {
        async getData() {
            if (this.route_name != 'PageUnivName' ) return '';
            if (!this.isKey) return '';
            
            let decrypt_data = decrypt(this.key);
            decrypt_data = decrypt_data.split('&&');

            var key = decrypt_data[0];
            this.keyword = key;
        },  
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">
    .sidebar-filter-name
        label
            font-size: 9px
            text-transform: uppercase
        font-size: 11px
    @media screen and (max-width: 480px)
        .sidebar-filter-name
            position: fixed
            width: 100vw
            height: 100vh
            overflow: auto
            top: 0
            right: 0
            bottom: 0
            left: 0
            background-color: $color-bg
            z-index: 1001
            padding: 16px
            font-size: 1em
            display: none
            label
                font-size: 0.75em
            button.btn
                height: 48px
            &.is-show
                display: block
</style> 
